import React from 'react'
import { Component } from 'react';
import { Link } from 'react-router-dom';
import authService from './AuthorizeService';
import { AuthenticationResultStatus } from './AuthorizeService';
import { LoginActions, QueryParameterNames, ApplicationPaths } from './ApiAuthorizationConstants';

export class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            message: undefined,
            loading: false
        };
    }

    componentDidMount() {
        const action = this.props.action;
        if (action === LoginActions.LoginCallback) {
            window.location.replace('/Medlem');
        } else if (action === LoginActions.Profile) {
            window.location.replace('/Medlem');
        } else if (action === LoginActions.LoginFailed) {
            const params = new URLSearchParams(window.location.search);
            const error = params.get(QueryParameterNames.Message);
            this.setState({ message: error });
        }
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true, message: undefined });

        const result = await authService.login(this.state.email, this.state.password);

        if (result.status === AuthenticationResultStatus.Success) {
            const returnUrl = this.getReturnUrl();
            window.location.replace(returnUrl || '/Medlem');
        } else {
            this.setState({ message: result.message, loading: false });
        }
    }

    getReturnUrl() {
        const params = new URLSearchParams(window.location.search);
        return params.get(QueryParameterNames.ReturnUrl);
    }

    render() {
        const action = this.props.action;

        if (action === LoginActions.Register) {
            return null;
        }

        const { message, loading } = this.state;

        return (
            <div>
                <h2>Logga in</h2>
                <p>Logga in nedan</p>
                <div className="row">
                    <div className="col-md-4">
                        <form onSubmit={this.handleSubmit}>
                            {message && <div className="text-danger mb-3">{message}</div>}
                            <div className="form-group mb-3">
                                <label htmlFor="email">E-post adress</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    value={this.state.email}
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                    required
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor="password">L&#246;senord</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    id="password"
                                    value={this.state.password}
                                    onChange={(e) => this.setState({ password: e.target.value })}
                                    required
                                />
                            </div>
                            <div className="form-group mb-3">
                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                    {loading ? 'Loggar in...' : 'Logga in'}
                                </button>
                            </div>
                            <div className="form-group">
                                <p>
                                    <Link to={ApplicationPaths.Register}>Bli medlem</Link>
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
